import {
  ALL_CONFIRM_SALES_ORDER_FAIL,
  ALL_CONFIRM_SALES_ORDER_REQUEST,
  ALL_CONFIRM_SALES_ORDER_SUCCESS,
} from "app/utils/constants/Constant/salesOrderConstant";

const INIT_STATE = {
  loading: false,
  error: null,
  confirmSales: [],
  TotalPage: null,
};

export const salesOrderReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALL_CONFIRM_SALES_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CONFIRM_SALES_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        confirmSales: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_CONFIRM_SALES_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        confirmSales: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
